import type { ReactNode } from "react";
import { useT } from "@transifex/react";
import { useGeneralContext } from "../../../context/AppGeneralContext";
import { creationFlowColors, CreationModes, getCreationMode } from "../../../constants/CreationFlowConstants";

interface CreationFlowSectionProps {
    description?: string;
    children?: ReactNode;
}

const CreationFlowSection = (props: CreationFlowSectionProps) => {
    const { creatingMode } = useGeneralContext();
    const colorKey = getCreationMode(creatingMode);
    const colors = creationFlowColors[colorKey];

    const t = useT();
    const t_practiceAndTest = t("Practice & Test", { _tags: "CreateTest, CreationFlowSection" });
    const t_vocabTrainer = t("Vocab Trainer", { _tags: "CreateTest, CreationFlowSection" });

    const label = colorKey === CreationModes.RECURRING_TASK ? t_vocabTrainer : t_practiceAndTest;

    return (
        <div className={"overflow-hidden rounded-t-medium border border-p6-grey-lightest"}>
            <div
                className="bg-white px-s py-s border-b-2"
                style={{ borderColor: colors.primary }}
            >
                <p
                    className="text-xl font-semibold uppercase break-words"
                    style={{ color: colors.primary }}
                >
                    {label}
                </p>
            </div>
            {props.description && <p className="bg-white px-s py-s text-l text-p6-grey-dark">{props.description}</p>}
            {props.children && <div className="bg-white">{props.children}</div>}
        </div>
    );
};

export default CreationFlowSection;
